import { Select } from "@normasteaching/norma-ui";
import { useOnboardingLiveConductors } from "./useOnboardingLiveConductors.ts";

const automaticConductorOptionId = "automatic";

export function ConductorSelect({
  value,
  onChange,
  disabled,
  excludedTeacherIds = [],
}: {
  value?: string | null;
  onChange: (teacherId?: string) => void;
  disabled?: boolean;
  excludedTeacherIds?: string[];
}) {
  const { conductors } = useOnboardingLiveConductors();
  return (
    <Select<string>
      disabled={disabled}
      searchable
      options={[
        {
          id: automaticConductorOptionId,
          name: "Automatico (chi ha condotto meno live)",
        },
        ...conductors.filter((c) => !excludedTeacherIds.includes(c.id)),
      ]}
      value={value ?? automaticConductorOptionId}
      onChange={(v) =>
        onChange(!v || v === automaticConductorOptionId ? undefined : v)
      }
    />
  );
}
